var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container col-12"},[_c('div',{staticClass:"d-flex flex-row-reverse mb-2"},[_c('b-button',{attrs:{"size":"sm","variant":"info","to":{ name: 'users_list' }}},[_vm._v("Gerenciar Usuários")])],1),_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.client.users,"fields":_vm.fields}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }